/**
 * Build params for waQueryContactsAndChatsTool from test inputs
 * Only includes non-default values to minimize payload
 *
 * Extracted to separate file to avoid pulling in puppeteer dependencies
 * from test-executors.ts
 */
export function buildQueryContactsAndChatsParams(i: Record<string, any>): Record<string, any> {
  const params: Record<string, any> = {};
  if (i.includeContacts === false) params.includeContacts = false;
  if (i.includeChats === false) params.includeChats = false;

  if (i.limit !== undefined && i.limit !== '') params.limit = Number(i.limit);
  if (i.offset && i.offset !== 0) params.offset = Number(i.offset);

  if (i.searchToken) params.searchToken = i.searchToken;
  if (i.filterGroups === true) params.filterGroups = true;
  if (i.filterContacts === true) params.filterContacts = true;
  if (i.filterNewsletters === true) params.filterNewsletters = true;

  if (i.includeWithoutName === true) params.includeWithoutName = true;
  if (i.includeLastMessage === true) params.includeLastMessage = true;
  if (i.includeArchive === true) params.includeArchive = true;

  return params;
}
